import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';

import CustomScrollbars from 'util/CustomScrollbars';
import ApoioUsuarioSide from './ApoioUsuarioSide';

class SidenavContent extends Component {
  componentDidMount() {
    const {history} = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`;// get current path

    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {

        const parentLiEle = that.closest(this, 'li');
        if(menuLi[i].classList.contains('menu') && parentLiEle !== null) {
          event.stopPropagation();

          if(menuLi[i].classList.contains('open')) {
            menuLi[i].classList.remove('open', 'active');
          } else {
            menuLi[i].classList.add('open', 'active');
          }
        } else {
          for (let j = 0; j < menuLi.length; j++) {
            const parentLi = that.closest(this, 'li');
            if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
              menuLi[j].classList.remove('open');
            } else {
              if(menuLi[j].classList.contains('open')) {
                menuLi[j].classList.remove('open');
              } else {
                menuLi[j].classList.add('open');
              }
            }
          }
        }
      }
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  componentWillReceiveProps(nextProps) {

    const {history} = nextProps;
    const pathname = `${history.location.pathname}`;// get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] === 'function') {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {

    }

    return null;
  }

  render() {
    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li className="menu no-arrow">
            <NavLink to="/app/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          <li className="menu no-arrow bg-success ml-3 mr-3 p-1">
            <NavLink to="/app/agendas/nova">
              <i className="zmdi zmdi-plus zmdi-hc-fw text-white"/>
              <span className="nav-text text-white">Novo Agendamento</span>
            </NavLink>
          </li>
          <li className="nav-header">
            Interação
          </li>
          <li className="menu no-arrow">
            <NavLink to="/app/agenda">
              <i className="zmdi zmdi-calendar zmdi-hc-fw"/>
              <span className="nav-text">Agenda</span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink to="/app/agendas/cancelado">
              <i className="zmdi zmdi-delete zmdi-hc-fw"/>
              <span className="nav-text">Cancelados</span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink to="/app/notificacao">
              <i className="zmdi zmdi-email zmdi-hc-fw"/>
              <span className="nav-text">Notificações</span>
            </NavLink>
          </li>
          <li className="nav-header">
            Doadores
          </li>
          <li className="menu no-arrow">
            <NavLink to="/app/doador">
              <i className="zmdi zmdi-accounts zmdi-hc-fw"/>
              <span className="nav-text">Doadores da unidade</span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink to="/app/plaqueta">
              <i className="zmdi zmdi-account-box-phone zmdi-hc-fw"/>
              <span className="nav-text">Plaquetas</span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink to="/app/falta">
              <i className="zmdi zmdi-account-box-o zmdi-hc-fw"/>
              <span className="nav-text">Bloqueados por falta</span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink to="/app/ativacao">
              <i className="zmdi zmdi-lock-open zmdi-hc-fw"/>
              <span className="nav-text">Ativar App</span>
            </NavLink>
          </li>
          <li className="nav-header">
            Suporte
          </li>
          <ApoioUsuarioSide/>
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(SidenavContent);
